import axios from "axios";
import {IOrderDetail, ISearchDetail} from "../../../models/OrderModel";
import {ResponseModel} from "../../../models/ResponseModel";
import {ADMIN_ORDER_ENDPOINT, EXPORT_QRCODE_ENDPOINT, INVOICE_CREATE, INVOICE_REPLACE, INVOICE_ADJUST, INVOICE_PREVIEW, INVOICE_DOWNLOAD, INVOICE_DOWNLOAD_BY_ID, INVOICE_SEND_EMAIL, INVOICE_ZIP, EXPORT_QRCODE_ENDPOINT_HTML} from "../../../constants/endpoints";
import { PaginateModel } from "../../../models/PaginateModel";
import { IAxiosSuccess } from "../../../models/AxiosModel";
import { isMobile } from "../../../modules/common/helper";

export interface ProductSaleListModel {
  paginate_data: PaginateModel<IOrderDetail>,
  sub_total: number
}

export function getDetail(params: ISearchDetail, mergeDate: any) {
  let id = params.id;
  const index = id?.indexOf("?");
  if (index && index > -1) {
    id = id?.substring(0, index);
  }
  if (mergeDate?.startDate && mergeDate?.endDate) {
    return axios.get<ResponseModel>(`${ADMIN_ORDER_ENDPOINT}/${params.id}?startDate=${mergeDate?.startDate}&endDate=${mergeDate?.endDate}`)
  } else {
    return axios.get<ResponseModel>(`${ADMIN_ORDER_ENDPOINT}/${params.id}`, {
      useLocal404Toast: true
    })
  }
}

export function searchProduct(params: ISearchDetail) {
  return axios.get<PaginateModel<IOrderDetail>>(`${ADMIN_ORDER_ENDPOINT}/find-inventory`, {params})
}

export function exportSearchProduct(params: ISearchDetail) {
  return axios.get(`${ADMIN_ORDER_ENDPOINT}/export-product-search`, {params, responseType: 'blob'})
}

export function upsertOrder(params: any) {
  return axios.post<ResponseModel>(`${ADMIN_ORDER_ENDPOINT}/upsert`, params)
}

export function exportPdf(params: { 
  id?: string, is_sento?: boolean, agency_id?: number, hideCols?: string[],
  startDate?: string,
  endDate?: string,
  layout?: string,
  is_pc?: number
}) {
  // if (params.layout === 'landscape') {
  //   return axios.post<Blob>(`${ADMIN_ORDER_ENDPOINT}/export-pdf`,params, {
  //     responseType: 'blob'
  //   })
  // }
  let endpoint = `${ADMIN_ORDER_ENDPOINT}/export-pdf`;
  if (params.layout === 'landscape') {
    endpoint = `${ADMIN_ORDER_ENDPOINT}/export-pdf-landscape`;
  }
  if (!isMobile()) {
    params = {...params, is_pc: 1}
  }
  return axios.post(endpoint, params)
}


export function exportQrCode(params: {reqData: {name: string, url: string, nums: number}[], isPrinter?: number}) {
  let endpoint = `${EXPORT_QRCODE_ENDPOINT_HTML}`;
  if (params.isPrinter) {
    endpoint = `${EXPORT_QRCODE_ENDPOINT}`;
  }
  
  return axios.post(endpoint,params)
  // if (params.isPrinter) {
  //   return axios.post(`${EXPORT_QRCODE_ENDPOINT}`,params)
  // }
  // return axios.post<Blob>(`${EXPORT_QRCODE_ENDPOINT}`,params, {
  //   responseType: 'blob'
  // })
}

export function printUnsavedORder(params: any) {
  return axios.post<ResponseModel>(`${ADMIN_ORDER_ENDPOINT}/print-unsaved`, params)
}


export function createInvoice(id: number | string) {
 return axios.post<any>(`${INVOICE_CREATE}/${id}`)
}

export function previewInvoice(id: number | string) {
 return axios.post(`${INVOICE_PREVIEW}/${id}`, {}, {
    responseType: 'blob',
  });
}

export function downloadInvoice(id: number | string) {
 return axios.post(`${INVOICE_DOWNLOAD}/${id}`, {}, {
    responseType: 'blob',
  });
}

export function zipDownloadInvoice(ids: number[]) {
 return axios.post(`${INVOICE_ZIP}`, {invoice_ids: ids}, {
    responseType: 'blob',
  });
}

export function sendEmailInvoice(id: number | string) {
 return axios.post<ResponseModel>(`${INVOICE_SEND_EMAIL}/${id}`)
}

export function replaceInvoice(id: number | string, adjustFormData: any) {
 return axios.post<any>(`${INVOICE_REPLACE}/${id}`, adjustFormData)
}

export function adjustInvoice(id: number | string, adjustFormData: any) {
 return axios.post<any>(`${INVOICE_ADJUST}/${id}`, adjustFormData)
}

export function downloadInvoicebyId(id: number | string) {
 return axios.post(`${INVOICE_DOWNLOAD_BY_ID}/${id}`, {}, {
    responseType: 'blob',
  });
}

export function productSaleReport(params: ISearchDetail) {
  return axios.get<ProductSaleListModel>(`${ADMIN_ORDER_ENDPOINT}/product-sale-report`, {params})
}

export function exportProductSaleReport(params: ISearchDetail) {
  return axios.get(`${ADMIN_ORDER_ENDPOINT}/export-product-sale`, {params, responseType: 'blob'})
}

export function voiceOrder(data: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_ORDER_ENDPOINT}/voice-order`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function detectProducts(data: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_ORDER_ENDPOINT}/detect-products`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function cancelOrder(id: number) {
  return axios.post<ResponseModel>(`${ADMIN_ORDER_ENDPOINT}/cancel`, {id})
}

export function togglePriceChanged(id: number) {
  return axios.post<ResponseModel>(`${ADMIN_ORDER_ENDPOINT}/toggle-price-changed`, {id})
}